import { WatchlistSeverityLevel } from 'graphql-query-contracts';
import type { TFunction } from 'i18next';

/**
 * Formats a WatchlistSeverityLevel enum value to its translated display text
 * @param level - The watchlist severity level enum value
 * @param t - The translation function from react-i18next
 * @returns The translated display text for the severity level
 */
export function formatWatchlistSeverityLevel(
  level: WatchlistSeverityLevel,
  t: TFunction
): string {
  switch (level) {
    case WatchlistSeverityLevel.WatchlistSeverityLevelHigh:
      return t('web.admin.channel.visitor.watchlist.levels.high');
    case WatchlistSeverityLevel.WatchlistSeverityLevelMedium:
      return t('web.admin.channel.visitor.watchlist.levels.medium');
    case WatchlistSeverityLevel.WatchlistSeverityLevelLow:
      return t('web.admin.channel.visitor.watchlist.levels.low');
    case WatchlistSeverityLevel.WatchlistSeverityLevelInvalid:
      return t('web.admin.channel.visitor.watchlist.levels.invalid');
    default:
      return t('web.admin.channel.visitor.watchlist.levels.invalid');
  }
}

